<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct para-style-override-3" id="toc_marker-5"><a href="#/Ruddy_Gore2#Contents-A">Acknowledgments</a></p>
<p class="fp">With thanks to Jean Greenwood of the tireless feet, Foong Ling Kong, Jenny Pausacker, Richard Revill, David Greagg, Themmy Garner (ol’ pal, ol’ buddy), Laurie (cariad) Horner, Matthew Gordon-Clark and the inimitable Jan Gordon-Clark, Tim Daly, Dr Andrea Walker, Brian Di Caffa, Sarah Jane Reeh, Stuart Reeh, Arnold Pears, the memory of my great-uncle Gwilym Davies, the Chinese Museum, the Performing Arts Museum, the management of Her Majesty’s Theatre and the archives of the Victoria Police.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ruddy_Gore-4.vue?2b5fc116